import { render, staticRenderFns } from "./InfoPopover.vue?vue&type=template&id=2d780128&scoped=true"
import script from "./InfoPopover.vue?vue&type=script&lang=js"
export * from "./InfoPopover.vue?vue&type=script&lang=js"
import style0 from "./InfoPopover.vue?vue&type=style&index=0&id=2d780128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d780128",
  null
  
)

export default component.exports